<template>
<svg viewBox="0 0 25 25" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZhuoLei1`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_d233406632__clip0_1283_3696)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.525269 4.45508C0.525269 3.35051 1.4207 2.45508 2.52527 2.45508H22.3268C23.4314 2.45508 24.3268 3.35051 24.3268 4.45508V6.55371C24.3268 7.65828 23.4314 8.55371 22.3268 8.55371H20.7521L21.8597 20.9911C21.9007 21.4503 21.5614 21.8547 21.102 21.8941C20.6426 21.9336 20.237 21.5933 20.1961 21.134L19.4124 12.334H5.43262L4.64887 21.134C4.60796 21.5933 4.20238 21.9336 3.74298 21.8941C3.28358 21.8547 2.94432 21.4503 2.98522 20.9911L4.09291 8.55371H2.52527C1.4207 8.55371 0.525269 7.65828 0.525269 6.55371V4.45508ZM5.58135 10.664H19.2636L19.0757 8.55371H5.76929L5.58135 10.664ZM2.27649 5.00215C2.27649 4.56032 2.63466 4.20215 3.07649 4.20215H21.7685C22.2103 4.20215 22.5685 4.56032 22.5685 5.00215V6.00371C22.5685 6.44554 22.2103 6.80371 21.7685 6.80371H3.07649C2.63466 6.80371 2.27649 6.44554 2.27649 6.00371V5.00215Z"/></g><defs><clipPath id="svg_d233406632__clip0_1283_3696"><path transform="translate(.525 .176)" d="M0 0H24V24H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconZhuoLei1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
